import * as _ from 'lodash';
import {
    CLEAR_STORE,
    FETCH_TASK_DETAILS,
    FETCH_TASK_DETAILS_SUCCESS,
    FETCH_TASK_DETAILS_ERROR,

    CANCEL_TASK,
    CANCEL_TASK_SUCCESS,
    CANCEL_TASK_ERROR,

    TASK_NOTICE_SEEN_SUCCESS,
    SELECT_QUOTATION,
    SELECT_QUOTATION_SUCCESS,
    SELECT_QUOTATION_FAIL,

    UPDATING_RATING_REVIEW,
    UPDATING_RATING_REVIEW_SUCCESS,
    UPDATING_RATING_REVIEW_FAIL,

    REQUEST_MORE_QUOTATION,
    REQUEST_MORE_QUOTATION_SUCCESS,
    REQUEST_MORE_QUOTATION_FAIL,

    ADD_PAYMENT_DETAILS,
    ADD_PAYMENT_DETAILS_SUCCESS,
    ADD_PAYMENT_DETAILS_ERROR,

    FETCH_INSPECTORS,
    FETCH_INSPECTORS_SUCCESS,
    FETCH_INSPECTORS_ERROR,

    CONFIG_TASK_DETAILS,

    UPDATE_TASK,
    UPDATE_TASK_SUCCESS,
    UPDATE_TASK_ERROR,

    RECEIVE_NOTICE_TASK_NOTIFICATION
} from '../actions/types'
import { ADVANCE_PAYMENT } from '../constants/taskStates';


const INITIAL_STATE = {
    _id: '',
    taskType: '',
    title: '',
    description: '',
    location: '',
    companyId: '',
    posterId: '',
    state: '',
    createdAt: '',
    taskLeader: {},

    inspectionDate: '',
    startingDate: '',
    completionDate: '',

    inspectors: [],
    candidateSPs: [],
    quotations: [],
    quoteRequestCount: null,
    advancePayment: {},
    finalPayment: {},
    invoices: [],
    latestInvoice: null,

    // Loading states
    isFetchingTaskDetails: false,
    isCancellingTask: false,
    isAddingPaymentDetails: false,
    isFetchingInspectors: false,
    isUpdatingTask: false,

    // Additional configs
    statusBarText: '',
    showCancelTaskBtn: false,
    showRatingAndReviews: false,
    showAddPaymentDetailsBtn: false,
    showRequestMoreQuotesBtn: false,
    showScrollToQuotationsBtn: false,
    showEditTaskButton: false,

    upadatingRatingReview: false,
    rating: null,
    review: null,

    isRequestedMoreQuotes: false,
    loadingRequestMoreQuotation: false,
    loadingSeletedQuotation: false,

    taskNotices: [],
    rejectReason: '',
    cancelReason: ''
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_TASK_DETAILS:
            return {
                ...INITIAL_STATE,
                isFetchingTaskDetails: true
            }
        case FETCH_TASK_DETAILS_SUCCESS:
            return {
                ...state,
                isFetchingTaskDetails: false,
                inspectors: _.get(action.payload.task, "inspectors", []),
                rating: _.get(action.payload.task, "rating", null),
                review: _.get(action.payload.task, "review", null),
                quotations: _.get(action.payload.task, "quotation", []),
                ...action.payload.task,
                invoices: _.get(action.payload.task, "invoices", []) || [],
                latestInvoice: _.get(action.payload.task, "latestInvoice", null) || null
            }
        case FETCH_TASK_DETAILS_ERROR:
            return {
                ...state,
                isFetchingTaskDetails: false
            }
        case CANCEL_TASK:
            return {
                ...state,
                isCancellingTask: true,
            }
        case CANCEL_TASK_SUCCESS:
            return {
                ...state,
                isCancellingTask: false,
                showCancelTaskBtn: false,
                showEditTaskButton: false,
                state: action.payload.state,
                cancelReason: action.payload.reason,
                statusBarText: `You cancelled this task for the reason, '${action.payload.reason}'`
            }
        case CANCEL_TASK_ERROR:
            return {
                ...state,
                isCancellingTask: false
            }
        case UPDATING_RATING_REVIEW:
            return {
                ...state,
                upadatingRatingReview: true,
                rating: null,
                review: null,
            }
        case UPDATING_RATING_REVIEW_SUCCESS:
            return {
                ...state,
                upadatingRatingReview: false,
                rating: action.payload.rating,
                review: action.payload.review,
                statusBarText: 'Your task was completed successfully and all payments were settled'
            }
        case UPDATING_RATING_REVIEW_FAIL:
            return {
                ...state,
                upadatingRatingReview: false,
            }
        case REQUEST_MORE_QUOTATION:
            return {
                ...state,
                loadingRequestMoreQuotation: true,
            }
        case REQUEST_MORE_QUOTATION_SUCCESS:
            let quoteRequestCount = action.payload.quoteRequestCount
            return {
                ...state,
                loadingRequestMoreQuotation: true,
                loadingRequestMoreQuotation: false,
                isRequestedMoreQuotes: true,
                quoteRequestCount: action.payload.quoteRequestCount,
                statusBarText: `You have requested an extra quote. You can select a quote once we send an extra quote. You have requested ${quoteRequestCount} extra ${quoteRequestCount === 1 ? 'quote' : 'quotes'} so far`
            }
        case REQUEST_MORE_QUOTATION_FAIL:
            return {
                ...state,
                loadingRequestMoreQuotation: false,
            }
        case SELECT_QUOTATION:
            return {
                ...state,
                loadingSeletedQuotation: true,
            }
        case SELECT_QUOTATION_SUCCESS:
            let updatedQuote = _.find(state.quotations, { '_id': action.payload.quoteId });
            if (!_.isUndefined(updatedQuote)) {
                updatedQuote.isSelected = true;
            }
            return {
                ...state,
                state: ADVANCE_PAYMENT,
                statusBarText: 'Please do the advance payment and submit the payment details',
                showAddPaymentDetailsBtn: true,
                showScrollToQuotationsBtn: false,
                loadingSeletedQuotation: false,
                taskLeader: action.payload.taskLeader,
                quotations: [updatedQuote]
            }
        case SELECT_QUOTATION_FAIL:
            return {
                ...state,
                loadingSeletedQuotation: false,
            }
        case TASK_NOTICE_SEEN_SUCCESS:
            let clone = [...state.taskNotices]
            _.map(clone, (notice) => {
                if (notice.id === action.payload.id) {
                    notice.isSeen = true
                }
            })
            return {
                ...state,
                taskNotices: clone
            }
        case ADD_PAYMENT_DETAILS:
            return {
                ...state,
                isAddingPaymentDetails: true
            }
        case ADD_PAYMENT_DETAILS_SUCCESS:
            if (action.payload.paymentDetails.paymentType === 'finalPayment') {
                return {
                    ...state,
                    isAddingPaymentDetails: false,
                    finalPayment: action.payload.paymentDetails,
                    statusBarText: "We've received your payment acknowledgement. We will verify it and notify you soon"
                }
            }
            else {
                return {
                    ...state,
                    isAddingPaymentDetails: false,
                    advancePayment: action.payload.paymentDetails,
                    statusBarText: "We've received your payment acknowledgement. We will verify it and notify you soon"
                }
            }

        case ADD_PAYMENT_DETAILS_ERROR:
            return {
                ...state,
                isAddingPaymentDetails: false
            }
        case FETCH_INSPECTORS:
            return {
                ...state,
                isFetchingInspectors: true
            }
        case FETCH_INSPECTORS_SUCCESS:
            return {
                ...state,
                isFetchingInspectors: false,
                inspectors: action.payload.inspectors
            }
        case FETCH_INSPECTORS_ERROR:
            return {
                ...state,
                isFetchingInspectors: false
            }
        case UPDATE_TASK:
            return {
                ...state,
                isUpdatingTask: true
            }
        case UPDATE_TASK_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isUpdatingTask: false
            }
        case UPDATE_TASK_ERROR:
            return {
                ...state,
                isUpdatingTask: false
            }
        case CONFIG_TASK_DETAILS:
            return {
                ...state,
                ...action.payload
            }
        case RECEIVE_NOTICE_TASK_NOTIFICATION:
            return {
                ...state,
                taskNotices: [...state.taskNotices, action.payload]
            }
        case CLEAR_STORE:
            return INITIAL_STATE;
        default:
            return state
    }
}